export function footerLogos() {
    const $window = $(window);
    const $slider = $(".footer-logos");

    $window.on("load resize", function () {
        $slider.each(function () {
            let $this = $(this);
            if ($window.innerWidth() >= 1024) {
                if ($this.hasClass("slick-initialized")) {
                    setTimeout(function () {
                        $this.slick('refresh');
                        $this.slick('unslick');
                    }, 500);
                }
            } else {
                if (!$this.hasClass("slick-initialized")) {
                    $this.slick({
                        slidesToScroll: 1,
                        slidesToShow: 2,
                        infinite: false,
                        arrows: false,
                        dots: true,
                        mobileFirst: true,
                        variableWidth: true,
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToScroll: 2,
                                    slidesToShow: 3
                                }
                            },
                        ]
                    });
                }
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/footerLogos.js